import { render, staticRenderFns } from "./TaskClock.component.vue?vue&type=template&id=62828184&scoped=true&"
import script from "./TaskClock.component.vue?vue&type=script&lang=js&"
export * from "./TaskClock.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskClock.component.vue?vue&type=style&index=0&id=62828184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62828184",
  null
  
)

export default component.exports